export const cartesianSum = (first = [], second = []) => [].concat(
  ...first.map(firstItem => second.map(secondItem => [].concat(firstItem, secondItem))),
);

export const cartesianProduct = (carrierValues, operatorValues) => {
  const combinations = [];
  carrierValues.forEach((carrier) => {
    operatorValues.forEach((operator) => {
      combinations.push([carrier, operator]);
    });
  });
  return combinations;
};
